import { normalizeNullValue } from '../address.utils';

export const flatField = {
    read(value) {
        return normalizeNullValue(value);
    },
};
